// V57.7 — Shared responsive grid for "10 things on a screen" layouts.
// V57.8 — Refined:
//   - Portrait: 3-col. Center the orphan if exactly 7 (3+3+1 → centered)
//     or exactly 10 (3+3+3+1 → centered).
//   - Landscape: 5-col. NO centering — 7=5+2, 10=5+5 exact.
//   - The centering wrapper only takes effect in portrait, via a media
//     query toggling its display rule.
//
// For other tile counts the grid flows naturally with no special last-row
// treatment.

export function FolderGrid({ children, ariaLabel }) {
  const count = Array.isArray(children) ? children.filter(Boolean).length : 1;
  // Apply orphan-centering rule when N=7 or N=10 in portrait.
  const isSeven = count === 7;
  const isTen = count === 10;
  const lastIndex = isSeven ? 6 : isTen ? 9 : -1;

  return (
    <div
      role={ariaLabel ? "list" : undefined}
      aria-label={ariaLabel}
      className="folder-grid"
      style={{
        display: "grid",
        gap: 16,
        width: "100%",
      }}
    >
      {Array.isArray(children) ? children.map((child, i) => {
        if (!child) return null;
        const isLast = (isSeven || isTen) && i === lastIndex;
        return isLast ? (
          <div key={i} className="folder-grid-orphan">
            <div className="folder-grid-orphan-tile">
              {child}
            </div>
          </div>
        ) : child;
      }) : children}

      <style>{`
        .folder-grid {
          grid-template-columns: repeat(3, minmax(0, 1fr));
        }
        /* Portrait: orphan tile spans all 3 cols and centers a sized child */
        .folder-grid-orphan {
          grid-column: 1 / -1;
          display: flex;
          justify-content: center;
        }
        .folder-grid-orphan-tile {
          width: calc((100% - 32px) / 3);
          max-width: 260px;
        }
        /* Landscape phone/tablet/desktop: 5-col grid, orphan wrapper
           reverts to a single normal cell — no centering, no row-span. */
        @media (orientation: landscape) and (min-width: 600px) {
          .folder-grid {
            grid-template-columns: repeat(5, minmax(0, 1fr));
          }
          .folder-grid-orphan {
            grid-column: auto;
            display: block;
          }
          .folder-grid-orphan-tile {
            width: 100%;
            max-width: none;
          }
        }
      `}</style>
    </div>
  );
}
